import iso3311a2 from "iso-3166-1-alpha-2";

export const getCountries = Object.keys(iso3311a2.countries).map((key) => {
  return { key, value: iso3311a2.countries[key] };
});
